import React, { useEffect, useState } from "react";
import { fetchTransactions } from "../api.js";
import TransactionList from "../components/TransactionList.jsx";

export default function TransactionWithPicture() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const [items, setItems] = useState([]);

  useEffect(() => {
    if (loggedIn) {
      fetchTransactions().then((data) => {
        setItems(data);
      });
    }
  }, [loggedIn]);

  function handleLogin(e) {
    e.preventDefault();
    if (password === "pass") {
      setLoggedIn(true);
      setPassword("");
      setError("");
    } else {
      setError("Wrong password");
    }
  }

  if (!loggedIn) {
    return (
      <div>
        <h2>Admin Login</h2>
        <form onSubmit={handleLogin}>
          <input
            style={{ width: "165px", marginRight: "50px" }}
            type="password"
            placeholder="Password, Check BE File (pass)"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button type="submit">Login</button>
        </form>
        {error && <p>{error}</p>}
      </div>
    );
  }

  return (
    <div>
      <h3>All Transactions</h3>
      <TransactionList items={items} showReceipt={true} />
    </div>
  );
}
